import React from 'react';
import { GridCell, Grid, Page } from 'styles';
import { copyFor } from 'config';
import { useBillingType } from 'hooks/use-billing-type.hook';
import { useParams } from 'react-router-dom';
import { ErrorPage } from 'components/errors';
import { LoadingPage } from 'components/loading';
import { ContactSupport } from 'components/modules/contact-support';
import { PageHeading } from 'components/page-heading';
import { BillPayCta } from 'pages/billing/components/bill-pay-cta';
import { BillingExplainer } from 'pages/billing/components/billing-explainer';
import { LatestStatementExplainer } from './components/latest-statement-explainer';

const getCopy = copyFor('billing');

export const EmptyState = () => {
  const { planId } = useParams<{ planId?: string }>();
  const { data, loading, error } = useBillingType({ planId });

  if (loading) return <LoadingPage />;
  if (error || !data) return <ErrorPage />;

  const { isUtilityConsolidatedBilling } = data;

  return (
    <Page small={{ padding: '0 0 24px' }}>
      <PageHeading page={getCopy('heading')} />
      <Grid width="100%" gap="24px">
        {isUtilityConsolidatedBilling ? (
          <>
            <GridCell
              rows={4}
              columns={7}
              small={{ columnStart: 1, columns: 8 }}
            >
              <BillingExplainer />
            </GridCell>
            <GridCell
              columnStart={8}
              columns={5}
              small={{ columnStart: 1, columns: 8 }}
            >
              <ContactSupport />
            </GridCell>
          </>
        ) : (
          <>
            <GridCell
              rows={4}
              columns={5}
              small={{ columnStart: 1, columns: 8 }}
            >
              <LatestStatementExplainer />
            </GridCell>
            <GridCell
              columnStart={6}
              columns={7}
              small={{ columnStart: 1, columns: 8 }}
            >
              <BillPayCta />
              <BillingExplainer />
              <ContactSupport margin={{ top: '24px' }} />
            </GridCell>
          </>
        )}
      </Grid>
    </Page>
  );
};
